<div class="label-content">
    <label *ngIf="labelType == LabelType.DEFAULT">{{labelText}}</label>
    <label *ngIf="labelType == LabelType.RECTANGLE || labelType == LabelType.CIRCLE || labelType == LabelType.SQUARE"  
        [classList]="labelType">{{labelText}}
    </label>
    <div *ngIf="labelType == LabelType.STAR || labelType == LabelType.RHOMBUS" class="container">
        <div [style]="{'width' : cssStyle.width, 'height': cssStyle.height}" [classList]="labelType"></div>
        <label class="star-label">Star</label>
    </div>
</div>